/*
 * act feed api service
 */

import {
  friendshipsCreate,
  mediaLike,
  mediaComment,
  mediaCommentOffensive
} from "@/api/ins_api_new/apis/ins_earn_coin";
export const following = async (userId: string, targetId: string) => {
  try {
    // const crstoken = await getInsCrsTokenFromCookie(userId);
    const result = await friendshipsCreate(userId, targetId);
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const liking = async (userId: string, medieId: string) => {
  try {
    const result = await mediaLike(userId, medieId);
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const commenting = async (
  userId: string,
  mediaId: string,
  comment: string
) => {
  try {
    const offensive = await mediaCommentOffensive(mediaId, comment, userId);
    const result = await mediaComment(offensive, comment, mediaId, userId);
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};
